import React from 'react';
import Loadable from 'react-loadable'
import DefaultLayout from './containers/DefaultLayout';
import {
	ADMIN_LOW
} from './constants/bitwiseOperations';


function Loading() {
  	return <div className="page-loader">
		<div className="preloader pls-white">
			<svg className="pl-circular" viewBox="25 25 50 50">
				<circle className="plc-path" cx={50} cy={50} r={20} />
				12355
			</svg>
		</div>
	</div>
}

const Dashboard = Loadable({
	loader: () => import('./views/Dashboard'),
	loading: Loading
});

const BranchDashboard = Loadable({
	loader: () => import('./views/Dashboard/BranchDashboard'),
	loading: Loading
});

const Reports = Loadable({
	loader: () => import('./views/Reports/Reports'),
	loading: Loading
});

const MapView = Loadable({
	loader: () => import('./views/Map/MapView'),
	loading: Loading
});

const CompanySettings = Loadable({
	loader: () => {
		const userSession = JSON.parse(localStorage.getItem("user"));
		if (userSession && userSession.account.type !== ADMIN_LOW) {
			return import('./views/Company/Settings.jsx');
		}
		else {
			//return import('./views/Dashboard');
			return import('./views/Tables/Orders/NewTableOrders.jsx');
		}
	},
	loading: Loading
});

const Sections = Loadable({
	loader: () => import('./views/Tables/Sections/SectionsTable'),
	loading: Loading
});

const CompanyBillings = Loadable({
	loader: () => import('./views/Company/Billings.jsx'),
	loading: Loading
});

const providerBillings = Loadable({
	loader: () => import('./views/Provider/Billings.jsx'),
	loading: Loading
});

const providerInvoice = Loadable({
	loader: () => import('./views/Provider/ProviderInvoice.jsx'),
	loading: Loading
});

const providerInvoiceDetails = Loadable({
	loader: () => import('./views/Provider/providerInvoiceDetails.jsx'),
	loading: Loading
});

const clientInvoice = Loadable({
	loader: () => import('./views/Client/ClientInvoice.jsx'),
	loading: Loading
});

const Invoice = Loadable({
	loader: () => import('./views/Company/CompanyInvoice.jsx'),
	loading: Loading
});

const BranchInvoice = Loadable({
	loader: () => import('./views/Company/BranchInvoice.jsx'),
	loading: Loading
});

const BranchInvoiceDetails = Loadable({
	loader: () => import('./views/Company/BranchInvoiceDetails.jsx'),
	loading: Loading
});

const InvoicesLot = Loadable({
	loader: () => import('./views/Company/CompanyInvoicesLot.jsx'),
	loading: Loading
});

const InvoiceDetails = Loadable({
	loader: () => import('./views/Company/InvoiceDetails.jsx'),
	loading: Loading
});

const CompanyCharges = Loadable({
	loader: () => import('./views/Company/Charges.jsx'),
	loading: Loading
});

const Companies = Loadable({
	loader: () => import('./views/Tables/Companies/Companies.js'),
	loading: Loading
});

const BranchGroupStatistics = Loadable({
	loader: () => import('./views/Statistics/BranchGroupStatistics.jsx'),
	loading: Loading
});

const BranchStatistics = Loadable({
	loader: () => import('./views/Statistics/BranchStatistics.jsx'),
	loading: Loading
});

const AdminInbox = Loadable({
    loader: () => import('./views/Chats/AdminInbox.jsx'),
    loading: Loading
});

/**
 * ------------------------------------------------------
 * 							TABLE
 * ------------------------------------------------------
 */

const AdminsManagement = Loadable({
	loader: () => import('./views/Tables/Admins/Admins.jsx'),
	loading: Loading
});
const AdminTypesManagement = Loadable({
	loader: () => import('./views/Tables/Admins/AdminType.jsx'),
	loading: Loading
});

const OrderManagement = Loadable({
	loader: () => import('./views/Tables/Orders/NewTableOrders.jsx'),
	loading: Loading
});

const ProviderManagement = Loadable({
	loader: () => import('./views/Tables/Providers/NewTableProviders.jsx'),
	loading: Loading
});

const ProviderDetails = Loadable({
	loader: () => import('./views/Provider/providerDetail.jsx'),
	loading: Loading
});

const ProviderSettings = Loadable({
	loader: () => import('./views/Provider/ProviderSettings.jsx'),
	loading: Loading
});

const ClientsManagement = Loadable({
	loader: () => import('./views/Tables/Clients/NewTableClients.jsx'),
	loading: Loading
});

const BranchGoodsManagement = Loadable({
	loader: () => import('./views/Tables/Goods/NewTableBranchGoods.jsx'),
	loading: Loading
});

const GoodsTypesManagement = Loadable({
	loader: () => import('./views/Tables/Goods/GoodsTypesTable.jsx'),
	loading: Loading
});

const featuredProducts = Loadable({
	loader: () => import('./views/Tables/Goods/featuredProductsTable.jsx'),
	loading: Loading
});
const GoodsManagement = Loadable({
	loader: () => import('./views/Tables/Goods/NewTableGoods.jsx'),
	loading: Loading
});
const GoodsEtaManagement = Loadable({
	loader: () => import('./views/Tables/Goods/TableEtaGoods.jsx'),
	loading: Loading
});

const PropertiesManagement = Loadable({
	loader: () => import('./views/Tables/Properties/index.jsx'),
	loading: Loading
});

const categoriesManagement = Loadable({
	loader: () => import('./views/Tables/Categories/Categories.jsx'),
	loading: Loading
});

/**
 * ------------------------------------------------------
 * 						DETAILS VIEW
 * ------------------------------------------------------
 */

const ClientDetails = Loadable({
	loader: () => import('./views/Client/clientDetail.jsx'),
	loading: Loading
});

const AdminDetails = Loadable({
	loader: () => import('./views/Admin/adminDetail.jsx'),
	loading: Loading
});

const OrderDetails = Loadable({
	loader: () => import('./views/Orders/orderDetails.jsx'),
	loading: Loading
});

const GoodDetails = Loadable({
	loader: () => import('./views/Goods/goodsDetails.jsx'),
	loading: Loading
});

const GoodTags = Loadable({
	loader: () => import('./views/Goods/goodsTags.jsx'),
	loading: Loading
});

const Branchs = Loadable({
	loader: () => import('./views/Tables/Branchs/TableBranchs.jsx'),
	loading: Loading
});

const BranchsTable = Loadable({
	loader: () => import('./views/Tables/allBranch/TableBranchs.jsx'),
	loading: Loading
});

const TodayOrders = Loadable({
	loader: () => import('./views/Tables/Orders/todayOrders.jsx'),
	loading: Loading
});

const NotificationsList = Loadable({
	loader: () => import('./views/Notification/NotificationsList.jsx'),
	loading: Loading
});
/**
 * ------------------------------------------------------
 * 							FORMS
 * ------------------------------------------------------
 */

const CreateOrder = Loadable({
	loader: () => import('./views/Orders/CreateOrder.js'),
	loading: Loading
});

const BranchCategoryCompanyTable = Loadable({
	loader: () => import('./views/Tables/Companies/BranchCategoryCompanyTable.jsx'),
	loading: Loading
});

const Banner = Loadable({
	loader: () => import('./views/Tables/Banners/TableBanner.jsx'),
	loading: Loading
});

const sendNotification = Loadable({
	loader: () => import('./views/Notification/SendNotificationFrom.jsx'),
	loading: Loading
});

const listsendNotification = Loadable({
	loader: () => import('./views/Notification/BroadcastMessage.jsx'),
	loading: Loading
});

const coupons = Loadable({
	loader: () => import('./views/Tables/Coupons/couponTable.jsx'),
	loading: Loading
});

const coupon = Loadable({
	loader: () => import('./views/Coupons/CouponDetails.jsx'),
	loading: Loading
});

const promo = Loadable({
	loader: () => import('./views/Tables/Promo/promoTable.jsx'),
	loading: Loading
});

/**
 * ------------------------------------------------------
 * 							FLEETS
 * ------------------------------------------------------
 */

const Fleets = Loadable({
    loader: () => import('./views/Fleets/index.jsx'),
    loading: Loading
});

const ServiceSuppliers = Loadable({
    loader: () => import('./views/ServiceSuppliers/index.jsx'),
    loading: Loading
});

const ServiceProfiles = Loadable({
    loader: () => import('./views/ServiceProfiles/index.jsx'),
    loading: Loading
});

const ServiceCharges = Loadable({
    loader: () => import('./views/ServiceCharges/index.jsx'),
    loading: Loading
});

const ListAssociations = Loadable({
    loader: () => import('./components/Fleets/Associations/ListAssociations.jsx'),
    loading: Loading
});


/**
 * ------------------------------------------------------
 * 							WEBHOOKS
 * ------------------------------------------------------
 */

const Webhooks = Loadable({
    loader: () => import('./views/webhooks/index.jsx'),
    loading: Loading
});

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routesLow = [
	{ path: '/', exact: true, lang_key: 'home', component: DefaultLayout },
	{ path: '/settings', exact: true, lang_key: 'company_settings', component: CompanySettings },
	{ path: '/settings/:id', exact: true, lang_key: 'company_settings', component: CompanySettings },
	{ path: '/company-billings', exact: true, lang_key: 'company_billings', component: CompanyBillings },
	{ path: '/provider-management/billings-:id', exact: true, lang_key: 'finance', component: providerBillings },
	{ path: '/provider-management/invoices-:id', exact: true, lang_key: 'invoices', component: providerInvoice },
	{ path: '/provider-management/invoice-details-:id', exact: true, lang_key: 'invoices', component: providerInvoiceDetails },
	{ path: '/company-billings/invoices', exact: true, lang_key: 'invoices', component: Invoice },
	{ path: '/branch-invoices', exact: true, lang_key: 'invoices', component: BranchInvoice },
	{ path: '/branch-invoices/:id', exact: true, lang_key: 'invoice', component: BranchInvoiceDetails },
	{ path: '/company-billings/invoices/invoices-lot', exact: true, lang_key: 'invoices_lot', component: InvoicesLot },
	{ path: '/company-billings/invoices/:id', exact: true, lang_key: 'invoice', component: InvoiceDetails },
	{ path: '/company-charges', exact: true, lang_key: 'company_charges', component: CompanyCharges },
	{ path: '/charges/:search', exact: true, lang_key: 'company_charges', component: CompanyCharges },
	{ path: '/company-charges/:ordenid', exact: true, lang_key: 'order', component: OrderDetails },
	{ path: '/sections', exact: true, lang_key: 'sections', component: Sections },

	{ path: '/branch-category-company', exact: true, lang_key: 'branch_categories', component: BranchCategoryCompanyTable },

	{ path: '/profile/:id', exact: true, lang_key: 'admin_details_breadcrumb', component: AdminDetails },
	{ path: '/clients-management', exact: true, lang_key: 'clients', component: ClientsManagement },
	{ path: '/clients-management/:id', exact: true, lang_key: 'details', component: ClientDetails },
	{ path: '/clients-management/:id/:ordenid', exact: true, lang_key: 'order', component: OrderDetails },
	{ path: '/order-management', exact: true, lang_key: 'orders', component: OrderManagement },
	{ path: '/order-management/search-:search', exact: true, component: OrderManagement },
	{ path: '/create-order', exact: true, lang_key: 'create', component: CreateOrder, branchRequired: true },
	{ path: '/order-management/edit-:id', exact: false, lang_key: 'edit', component: CreateOrder },
	{ path: '/order-management/:ordenid', exact: true, strict: true, lang_key: 'details', component: OrderDetails },
	{ path: '/provider-management', exact: true, lang_key: 'providers', component: ProviderManagement },
	{ path: '/provider-management/:id', exact: true, lang_key: 'details', component: ProviderDetails },
	{ path: '/provider-management/:id/:ordenid', exact: true, lang_key: 'order', component: OrderDetails },
	{ path: '/goods-management', exact: true, lang_key: 'goods', component: GoodsManagement },
	{ path: '/featured-products', exact: true, lang_key: 'goods', component: featuredProducts },
	{ path: '/eta', exact: true, lang_key: 'eta', component: GoodsEtaManagement },
	{ path: '/branchs', exact: true, lang_key: 'branchs', component: Branchs },
	{ path: '/goods-tags', exact: true, lang_key: 'goods', component: GoodTags },
	{ path: '/goods-management/:branchId/:id', exact: true, lang_key: 'details', component: GoodDetails },
	{ path: '/good-type-management', exact: true, lang_key: 'branch_goods', component: GoodsTypesManagement },
	{ path: '/categories-management', exact: true, lang_key: 'categories', component: categoriesManagement },
	{ path: '/properties-management', exact: true, lang_key: 'properties', component: PropertiesManagement, branchRequired: true },
	{ path: '/notifications', exact: true,lang_key: 'notifications', component: NotificationsList },
	{ path: '/dashboard', exact: true, component: Dashboard },
	{ path: '/branchDashboard', exact: true, component: BranchDashboard },
	{ path: '/reports', lang_key: 'reports', exact: true, component: Reports },
	{ path: '/map', exact: true, component: MapView },
	{ path: '/today-orders', exact: true, component: TodayOrders },
    { path: '/inbox', exact: true, lang_key: "inbox", component: AdminInbox },
	{ path: '/fleets', lang_key: 'fleets', exact: true, component: Fleets },
	{ path: '/service-suppliers', lang_key: 'service_suppliers', exact: true, component: ServiceSuppliers },
	{ path: '/service-profiles', lang_key: 'service_profiles', exact: true, component: ServiceProfiles },
	{ path: '/service-charges', lang_key: 'service_charges', exact: true, component: ServiceCharges },
    { path: '/fleet-associations', lang_key: 'associations', exact: true, component: ListAssociations },
	{ path: '/branch-statistics', lang_key: 'branches', exact: true, component: BranchStatistics },
	{ path: '/branch-group-statistics', lang_key: 'branch_groups', exact: true, component: BranchGroupStatistics },
    { path: '/webhooks', lang_key: 'webhooks', exact: true, component: Webhooks },
].map(route => {
	if (route.branchRequired === undefined) {
		route.branchRequired = false
	}
	return route
})

const routesHigh = [
    { path: "/", exact: true, lang_key: "home", component: DefaultLayout },
    {
        path: "/settings",
        exact: true,
        lang_key: "company_settings",
        component: CompanySettings,
    },
    {
        path: "/settings/:id",
        exact: true,
        lang_key: "company_settings",
        component: CompanySettings,
    },
    {
        path: "/company-billings",
        exact: true,
        lang_key: "company_billings",
        component: CompanyBillings,
    },
    {
        path: "/company-billings",
        exact: true,
        lang_key: "company_billings",
        component: CompanyBillings,
    },
    {
        path: "/provider-management/billings-:id",
        exact: true,
        lang_key: "finance",
        component: providerBillings,
    },
    {
        path: "/provider-management/invoices-:id",
        exact: true,
        lang_key: "invoices",
        component: providerInvoice,
    },
    {
        path: "/provider-management/invoice-details-:id",
        exact: true,
        lang_key: "invoices",
        component: providerInvoiceDetails,
    },
    {
        path: "/branch-invoices",
        exact: true,
        lang_key: "invoices",
        component: BranchInvoice,
    },
    {
        path: "/branch-invoices/:id",
        exact: true,
        lang_key: "invoice",
        component: BranchInvoiceDetails,
    },
    {
        path: "/company-billings/invoices",
        exact: true,
        lang_key: "invoices",
        component: Invoice,
    },
    {
        path: "/company-billings/invoices/invoices-lot",
        exact: true,
        lang_key: "invoices_lot",
        component: InvoicesLot,
    },
    {
        path: "/company-billings/invoices/:id",
        exact: true,
        lang_key: "invoice",
        component: InvoiceDetails,
    },
    {
        path: "/company-charges",
        exact: true,
        lang_key: "company_charges",
        component: CompanyCharges,
    },
    {
        path: "/charges/:search",
        exact: true,
        lang_key: "company_charges",
        component: CompanyCharges,
    },
    {
        path: "/company-charges/:ordenid",
        exact: true,
        lang_key: "order",
        component: OrderDetails,
    },
    {
        path: "/admins-management",
        exact: true,
        lang_key: "admins",
        component: AdminsManagement,
    },
    {
        path: "/admin-types-management",
        exact: true,
        lang_key: "admin_types",
        component: AdminTypesManagement,
    },
    {
        path: "/profile/:id",
        exact: true,
        lang_key: "admin_details_breadcrumb",
        component: AdminDetails,
    },
    {
        path: "/clients-management",
        exact: true,
        lang_key: "clients",
        component: ClientsManagement,
    },
    {
        path: "/clients-management/billings-:id",
        exact: true,
        lang_key: "finance",
        component: clientInvoice,
    },
    {
        path: "/clients-management/:id",
        exact: true,
        lang_key: "details",
        component: ClientDetails,
    },
    {
        path: "/clients-management/:id/:ordenid",
        exact: true,
        lang_key: "order",
        component: OrderDetails,
    },
    {
        path: "/order-management",
        exact: true,
        lang_key: "orders",
        component: OrderManagement,
    },
    {
        path: "/order-management/search-:search",
        exact: true,
        component: OrderManagement,
    },
    {
        path: "/create-order",
        exact: true,
        lang_key: "create",
        component: CreateOrder,
        branchRequired: true,
    },
    {
        path: "/order-management/edit-:id",
        exact: true,
        lang_key: "edit_order",
        component: CreateOrder,
    },
    {
        path: "/order-management/:ordenid",
        exact: true,
        strict: true,
        lang_key: "details",
        component: OrderDetails,
    },
    {
        path: "/provider-management",
        exact: true,
        lang_key: "providers",
        component: ProviderManagement,
    },
    {
        path: "/provider-settings",
        exact: true,
        lang_key: "order",
        component: ProviderSettings,
    },
    {
        path: "/provider-management/:id",
        exact: true,
        lang_key: "details",
        component: ProviderDetails,
    },
    {
        path: "/provider-management/:id/:ordenid",
        exact: true,
        lang_key: "order",
        component: OrderDetails,
    },
    {
        path: "/branch-category-company",
        exact: true,
        lang_key: "branch_categories",
        component: BranchCategoryCompanyTable,
    },
    {
        path: "/goods-management",
        exact: true,
        lang_key: "goods",
        component: GoodsManagement,
    },
    {
        path: "/good-type-management",
        exact: true,
        lang_key: "branch_goods",
        component: GoodsTypesManagement,
    },
    {
        path: "/goods-management/branch",
        exact: true,
        lang_key: "branch_goods",
        component: BranchGoodsManagement,
    },
    {
        path: "/eta",
        exact: true,
        lang_key: "eta",
        component: GoodsEtaManagement,
    },
    { path: "/branchs", exact: true, lang_key: "branchs", component: Branchs },
    {
        path: "/branchs-list",
        exact: true,
        lang_key: "branchs",
        component: BranchsTable,
    },
    {
        path: "/goods-tags",
        exact: true,
        lang_key: "goods",
        component: GoodTags,
    },
    {
        path: "/goods-management/:branchId/:id",
        exact: true,
        lang_key: "details",
        component: GoodDetails,
    },
    {
        path: "/featured-products",
        exact: true,
        lang_key: "goods",
        component: featuredProducts,
    },
    {
        path: "/categories-management",
        exact: true,
        lang_key: "categories",
        component: categoriesManagement,
    },
    {
        path: "/properties-management",
        exact: true,
        lang_key: "properties",
        component: PropertiesManagement,
        branchRequired: true,
    },
    {
        path: "/notifications",
        exact: true,
        lang_key: "notifications",
        component: NotificationsList,
    },
    { path: "/dashboard", exact: true, component: Dashboard },
    { path: "/branchDashboard", exact: true, component: BranchDashboard },
    { path: "/reports", lang_key: "reports", exact: true, component: Reports },
    {
        path: "/sections",
        exact: true,
        lang_key: "sections",
        component: Sections,
    },
    { path: "/map", exact: true, component: MapView },
    { path: "/today-orders", exact: true, component: TodayOrders },
    { path: "/banners", exact: true, lang_key: "promotional_banners", component: Banner },
    {
        path: "/list-send-notifications/send-notification",
        exact: true,
        lang_key: "send_notification",
        component: sendNotification,
    },
    {
        path: "/list-send-notifications",
        exact: true,
        lang_key: "list_send_notifications",
        component: listsendNotification,
    },
    { path: "/coupons", exact: true, lang_key: "coupons", component: coupons },
    {
        path: "/coupons/:id",
        exact: true,
        lang_key: "coupon",
        component: coupon,
    },
    { path: "/promos", exact: true, lang_key: "promos", component: promo },
    { path: "/promos/:id", exact: true, lang_key: "promo", component: coupon },
    { path: '/inbox', exact: true, lang_key: "inbox", component: AdminInbox },
    { path: '/fleets', lang_key: 'fleets', exact: true, component: Fleets },
    { path: '/service-suppliers', lang_key: 'service_suppliers', exact: true, component: ServiceSuppliers },
    { path: '/service-profiles', lang_key: 'service_profiles', exact: true, component: ServiceProfiles },
    { path: '/service-charges', lang_key: 'service_charges', exact: true, component: ServiceCharges },
    { path: '/fleet-associations', lang_key: 'associations', exact: true, component: ListAssociations },
	{ path: '/branch-statistics', lang_key: 'branches', exact: true, component: BranchStatistics },
	{ path: '/branch-group-statistics', lang_key: 'branch_groups', exact: true, component: BranchGroupStatistics },
    { path: '/webhooks', lang_key: 'webhooks', exact: true, component: Webhooks },
].map((route) => {
    if (route.branchRequired === undefined) {
        route.branchRequired = false;
    }
    return route;
});

const routesSuper = [
    { path: "/", exact: true, lang_key: "home", component: DefaultLayout },
    {
        path: "/companies",
        exact: true,
        lang_key: "companies",
        component: Companies,
    },
    {
        path: "/settings",
        exact: true,
        lang_key: "company_settings",
        component: CompanySettings,
    },
    {
        path: "/settings/:id",
        exact: true,
        lang_key: "company_settings",
        component: CompanySettings,
    },
    {
        path: "/company-billings",
        exact: true,
        lang_key: "company_billings",
        component: CompanyBillings,
    },
    {
        path: "/provider-management/billings-:id",
        exact: true,
        lang_key: "finance",
        component: providerBillings,
    },
    {
        path: "/provider-management/invoices-:id",
        exact: true,
        lang_key: "invoices",
        component: providerInvoice,
    },
    {
        path: "/provider-management/invoice-details-:id",
        exact: true,
        lang_key: "invoices",
        component: providerInvoiceDetails,
    },
    {
        path: "/branch-invoices",
        exact: true,
        lang_key: "invoices",
        component: BranchInvoice,
    },
    {
        path: "/branch-invoices/:id",
        exact: true,
        lang_key: "invoice",
        component: BranchInvoiceDetails,
    },
    {
        path: "/company-billings/invoices",
        exact: true,
        lang_key: "invoices",
        component: Invoice,
    },
    {
        path: "/company-billings/invoices/invoices-lot",
        exact: true,
        lang_key: "invoices_lot",
        component: InvoicesLot,
    },
    {
        path: "/company-billings/invoices/:id",
        exact: true,
        lang_key: "invoice",
        component: InvoiceDetails,
    },
    {
        path: "/company-charges",
        exact: true,
        lang_key: "company_charges",
        component: CompanyCharges,
    },
    {
        path: "/charges/:search",
        exact: true,
        lang_key: "company_charges",
        component: CompanyCharges,
    },
    {
        path: "/company-charges/:ordenid",
        exact: true,
        lang_key: "order",
        component: OrderDetails,
    },
    {
        path: "/admins-management",
        exact: true,
        lang_key: "admins",
        component: AdminsManagement,
    },
    {
        path: "/admin-types-management",
        exact: true,
        lang_key: "admin_types",
        component: AdminTypesManagement,
    },
    {
        path: "/profile/:id",
        exact: true,
        lang_key: "admin_details_breadcrumb",
        component: AdminDetails,
    },
    {
        path: "/clients-management",
        exact: true,
        lang_key: "clients",
        component: ClientsManagement,
    },
    {
        path: "/clients-management/billings-:id",
        exact: true,
        lang_key: "finance",
        component: clientInvoice,
    },
    {
        path: "/clients-management/:id",
        exact: true,
        lang_key: "details",
        component: ClientDetails,
    },
    {
        path: "/clients-management/:id/:ordenid",
        exact: true,
        lang_key: "order",
        component: OrderDetails,
    },
    {
        path: "/order-management",
        exact: true,
        lang_key: "orders",
        component: OrderManagement,
    },
    {
        path: "/order-management/search-:search",
        exact: true,
        component: OrderManagement,
    },
    {
        path: "/order-management/create",
        exact: true,
        lang_key: "create",
        component: CreateOrder,
        branchRequired: true,
    },
    {
        path: "/order-management/edit-:id",
        exact: true,
        lang_key: "edit_order",
        component: CreateOrder,
    },
    {
        path: "/order-management/:ordenid",
        exact: true,
        strict: true,
        lang_key: "details",
        component: OrderDetails,
    },
    {
        path: "/provider-management",
        exact: true,
        lang_key: "providers",
        component: ProviderManagement,
    },
    {
        path: "/provider-settings",
        exact: true,
        lang_key: "order",
        component: ProviderSettings,
    },
    {
        path: "/provider-management/:id",
        exact: true,
        lang_key: "details",
        component: ProviderDetails,
    },
    {
        path: "/provider-management/:id/:ordenid",
        exact: true,
        lang_key: "order",
        component: OrderDetails,
    },
    {
        path: "/goods-tags",
        exact: true,
        lang_key: "goods",
        component: GoodTags,
    },
    { path: "/branchs", exact: true, lang_key: "branchs", component: Branchs },
    {
        path: "/branchs-list",
        exact: true,
        lang_key: "branchs",
        component: BranchsTable,
    },
    {
        path: "/goods-management",
        exact: true,
        lang_key: "goods",
        component: GoodsManagement,
    },
    {
        path: "/featured-products",
        exact: true,
        lang_key: "goods",
        component: featuredProducts,
    },
    {
        path: "/eta",
        exact: true,
        lang_key: "eta",
        component: GoodsEtaManagement,
    },
    {
        path: "/goods-management/branch",
        exact: true,
        lang_key: "branch_goods",
        component: BranchGoodsManagement,
    },
    {
        path: "/branch-category-company",
        exact: true,
        lang_key: "branch_categories",
        component: BranchCategoryCompanyTable,
    },
    {
        path: "/goods-management/:branchId/:id",
        exact: true,
        lang_key: "details",
        component: GoodDetails,
    },
    {
        path: "/good-type-management",
        exact: true,
        lang_key: "branch_goods",
        component: GoodsTypesManagement,
    },
    {
        path: "/categories-management",
        exact: true,
        lang_key: "categories",
        component: categoriesManagement,
    },
    {
        path: "/properties-management",
        exact: true,
        lang_key: "properties",
        component: PropertiesManagement,
        branchRequired: true,
    },
    {
        path: "/notifications",
        exact: true,
        lang_key: "notifications",
        component: NotificationsList,
    },
    { path: "/dashboard", exact: true, component: Dashboard },
    { path: "/branchDashboard", exact: true, component: BranchDashboard },
    { path: "/reports", lang_key: "reports", exact: true, component: Reports },
    { path: "/map", exact: true, component: MapView },
    { path: "/today-orders", exact: true, component: TodayOrders },
    { path: "/banners", exact: true, lang_key: "promotional_banners", component: Banner },
    {
        path: "/list-send-notifications/send-notification",
        exact: true,
        lang_key: "send_notification",
        component: sendNotification,
    },
    {
        path: "/list-send-notifications",
        exact: true,
        lang_key: "list_send_notifications",
        component: listsendNotification,
    },
    { path: "/coupons", exact: true, lang_key: "coupons", component: coupons },
    {
        path: "/coupons/:id",
        exact: true,
        lang_key: "coupon",
        component: coupon,
    },
    { path: "/promos", exact: true, lang_key: "promos", component: promo },
    { path: "/promos/:id", exact: true, lang_key: "promo", component: coupon },
    {
        path: "/sections",
        exact: true,
        lang_key: "sections",
        component: Sections,
    },
    { path: '/inbox', exact: true, lang_key: "inbox", component: AdminInbox },
    { path: '/fleets', lang_key: 'fleets', exact: true, component: Fleets },
    { path: '/service-suppliers', lang_key: 'service_suppliers', exact: true, component: ServiceSuppliers },
    { path: '/service-profiles', lang_key: 'service_profiles', exact: true, component: ServiceProfiles },
    { path: '/service-charges', lang_key: 'service_charges', exact: true, component: ServiceCharges },
    { path: '/fleet-associations', lang_key: 'associations', exact: true, component: ListAssociations },
    { path: '/branch-statistics', lang_key: 'branches', exact: true, component: BranchStatistics },
	{ path: '/branch-group-statistics', lang_key: 'branch_groups', exact: true, component: BranchGroupStatistics },
    { path: '/webhooks', lang_key: 'webhooks', exact: true, component: Webhooks },
].map((route) => {
    if (route.branchRequired === undefined) {
        route.branchRequired = false;
    }
    return route;
});

export {
	routesHigh,
	routesLow,
	routesSuper
}



// WEBPACK FOOTER //
// ./src/routes.js